import { queryOptions } from "@tanstack/react-query";
import { ApiError, api, unwrap } from "@/client/lib/api";
import type { JoinLanding } from "@/features/invitation/schemas";

/**
 * Null when the token opens nothing: the landing page words a dead link, so it never reaches the
 * error boundary.
 */
export const joinQuery = (token: string) =>
  queryOptions({
    queryKey: ["join", token],
    queryFn: async (): Promise<JoinLanding | null> => {
      try {
        return await unwrap(api.join[":token"].$get({ param: { token } }));
      } catch (failure) {
        if (failure instanceof ApiError && failure.code === "NOT_FOUND") {
          return null;
        }
        throw failure;
      }
    },
  });
